export class BaseDataTableModel {
  isNotDeletable?: boolean;
  isNotArchivable?: boolean;
  noAction?: boolean;
  customDisplay?: any;
}
